<template lang="pug">
  .height-100
    h3.title Gestión de contratos
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(v-if="mostrarListaSolicitudesAprobadas", key="lista_solicitudes_aprobadas")
        lista-solicitudes-aprobadas(
          @close="mostrarListaSolicitudesAprobadas = false"
        )

</template>

<script>
import ListaSolicitudRenovacionContratoAprobadasComponent from './Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Aprobadas'
export default {
  name: 'contratos-equipo',
  components: {
    'lista-solicitudes-aprobadas': ListaSolicitudRenovacionContratoAprobadasComponent
  },
  data () {
    return {
      mostrarListaSolicitudesAprobadas: true
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Contratos_Gestion.vue?143cf158